<template>
  <span>
    <h1
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '25px' : '' }"
      style="margin: 0; padding: 0 15px;"
    >
     {{$t('userEdit.edsVirtualAttendant')}}
    </h1>
    <h3
      :style="{ fontSize: $vuetify.breakpoint.xsOnly ? '20px' : '' }"
      style="margin-top: 0; margin-bottom: 20px; padding: 0 15px;"
    >
      {{ $t("commonWords.users") }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item ml-auto">
        <md-button @click="toUserList" class="md-twitter" style="float: right;">
          <span style="color: black">{{ $t("commonWords.back") }}</span>
        </md-button>
      </div>
    </div>
    <v-row no-gutters style="width: 100%; justify-content: center">
      <v-col sm="12" md="8" lg="6" xl="4">
        <v-row no-gutters>
          <v-col style="padding: 0 20px">
            <md-card>
              <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                  <md-icon>person</md-icon>
                </div>
              </md-card-header>

              <md-card-content>
                <form class="form-horizontal" action="" method="post">
                  <div class="md-layout">
                    <md-field style="margin-top: 30px">
                      <label>{{ $t("usersEdit.name") }} *</label>
                      <md-input v-model="user.name"></md-input>
                    </md-field>
                    <md-field>
                      <label>{{ $t("usersEdit.email") }} *</label>
                      <md-input v-model="user.email"></md-input>
                    </md-field>
                    <md-field>
                      <label>{{ $t("usersEdit.password") }} *</label>
                      <md-input
                        type="password"
                        v-model="user.password"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label
                        >{{ $t("usersEdit.confirm") }}
                        {{ $t("usersEdit.password") }} *</label
                      >
                      <md-input
                        type="password"
                        v-model="user.confirmPassword"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>{{ $t("usersEdit.profile") }} *</label>
                      <md-select v-model="user.profile">
                        <md-option value="administrador"
                          >{{$t('userEdit.administrator')}}</md-option
                        >
                        <md-option value="analista">{{$t('userEdit.analyst')}}</md-option>
                        <md-option value="revistor">{{$t('userEdit.reviewer')}}</md-option>
                      </md-select>
                    </md-field>
                    <div style="width: 100%;">
                      <div
                        class="md-layout"
                        style="width: 100%; justify-content: center"
                      >
                        <div
                          class="md-layout-item"
                          style="padding-top: 0; padding-bottom: 0; margin: auto 0; text-align: right"
                          :class="{
                            'text-success': user.enabled,
                            'text-danger': !user.enabled
                          }"
                        >
                          {{
                            user.enabled
                              ? $t("commonWords.enabled")
                              : $t("commonWords.disabled")
                          }}
                        </div>
                        <div class="md-layout-item" style="margin: auto 0;">
                          <md-switch v-model="user.enabled"></md-switch>
                        </div>
                      </div>
                    </div>
                    <div style="width: 100%;">
                      <div
                        class="md-layout"
                        style="width: 100%; justify-content: center"
                      >
                        <md-button class="md-success">
                          <span style="color: black">{{
                            $t("commonWords.create")
                          }}</span>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </form>
              </md-card-content>
            </md-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  data () {
    return {
      user: {
        name: '',
        email: 'italo.r.souza@hotmail.com',
        password: 'aaaaaa',
        confirmPassword: 'aaaaaa',
        profile: 'analista',
        enabled: true
      }
    }
  },
  methods: {
    toUserList () {
      this.$router.push('/lista-usuarios')
    }
  }
}
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
